import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
export const DEFAULT_VALUE = 'unspecified';
export const GUEST_USER_NAME = 'guest';
export var DigitalDataMutation;
(function (DigitalDataMutation) {
    DigitalDataMutation["ADD_TO_WISHLIST"] = "add-to-wishlist";
    DigitalDataMutation["REMOVE_FROM_WISHLIST"] = "remove-from-wishlist";
    DigitalDataMutation["PLP_VIEW_FILTER_RESULT"] = "plp-view-filter-result";
    DigitalDataMutation["PLP_VIEW_FILTER_RESULT_BLOOMREACH"] = "plp-view-filter-result-bloomreach";
    DigitalDataMutation["SMART_FIT_START"] = "smartfit-click-start";
    DigitalDataMutation["SMART_FIT_USAGE_INSIGHTS"] = "smartfit";
    DigitalDataMutation["CART_SHARE_QR"] = "cart-share-qrcode";
    DigitalDataMutation["CART_SHARE_EMAIL"] = "cart-share-email";
    DigitalDataMutation["DEALER_LOCATOR_PLAN_A_ROUTE"] = "dealer-locator-plan-a-route";
    DigitalDataMutation["DEALER_LOCATOR_CONTACT"] = "dealer-locator-contact";
    DigitalDataMutation["LOGOUT"] = "logout";
    DigitalDataMutation["SEGMENT_PANEL_LOAD"] = "segment-panel-load";
    DigitalDataMutation["COMPATIBILITY_RESULT_POSITIVE"] = "compatibility-result-positive";
    DigitalDataMutation["COMPATIBILITY_RESULT_NEGATIVE"] = "compatibility-result-negative";
    DigitalDataMutation["SEGMENT_PANEL_CLICK"] = "segment-panel-click";
    DigitalDataMutation["CONFIGURATOR_START"] = "configurator-select-product";
    DigitalDataMutation["COMPARE_SPECIFICATIONS_CLICK"] = "compare-specifications-click";
    DigitalDataMutation["MAINTENANCE_FORM_ENTRY"] = "maintenance-form-entry";
    DigitalDataMutation["LEAD_FORM_ENTRY"] = "lead-form-entry";
    DigitalDataMutation["CONFIGURATOR_FORM_ENTRY"] = "configurator-form-entry";
    DigitalDataMutation["COMPATIBILITY_FORM_ENTRY"] = "compatibility-form-entry";
    DigitalDataMutation["MAINTENANCE_CONFIRMATION"] = "maintenance-confirmation";
    DigitalDataMutation["CONFIGURATOR_CONFIRMATION"] = "configurator-confirmation";
    DigitalDataMutation["LEAD_CONFIRMATION"] = "lead-confirmation";
    DigitalDataMutation["MAINTENANCE_SEARCH_DEALER"] = "maintenance-search-dealer";
    DigitalDataMutation["LEAD_SEARCH_DEALER"] = "lead-search-dealer";
    DigitalDataMutation["CONFIGURATOR_SEARCH_DEALER"] = "configurator-search-dealer";
    DigitalDataMutation["MAINTENANCE_SELECT_DEALER"] = "maintenance-select-dealer";
    DigitalDataMutation["LEAD_SELECT_DEALER"] = "lead-select-dealer";
    DigitalDataMutation["CONFIGURATOR_SELECT_DEALER"] = "configurator-select-dealer";
    DigitalDataMutation["TEST_RIDE_SELECT_DEALER"] = "test-ride-select-dealer";
    DigitalDataMutation["TEST_RIDE_SELECT_ITEM"] = "test-ride-select-item";
    DigitalDataMutation["COMPARE_TEST_RIDE_SELECT_ITEM"] = "compare-test-ride-select-item";
    DigitalDataMutation["DEALER_LOCATOR_SELECT_SERVICE"] = "dealer-locator-select-service";
    DigitalDataMutation["PDP_VIEW"] = "pdp-view";
    DigitalDataMutation["DATA_LAYER"] = "data-layer";
    DigitalDataMutation["SET_USER"] = "set-user";
    DigitalDataMutation["SET_PAGE"] = "set-page";
    DigitalDataMutation["SET_WEB_SITE"] = "set-web-site";
    DigitalDataMutation["PLP_VIEW"] = "plp-view";
    DigitalDataMutation["PLP_BLOOMREACH_VIEW"] = "plp-bloomreach_view";
    DigitalDataMutation["TEST_RIDE_VIEW_SEGMENT"] = "test-ride-view-segment-page";
    DigitalDataMutation["TEST_RIDE_VIEW_CATEGORY"] = "test-ride-view-category-page";
    DigitalDataMutation["EMAIL_SUBSCRIPTION"] = "email-subscription";
    DigitalDataMutation["CP_VIEW"] = "content-page-view";
    DigitalDataMutation["RMV_CMP"] = "remove-from-comparison";
    DigitalDataMutation["ADD_CMP"] = "add-to-comparison";
    DigitalDataMutation["ADD_TO_CART"] = "add-to-cart";
    DigitalDataMutation["CLEAR_LINE_ITEMS"] = "clear_line_items";
    DigitalDataMutation["REMOVE_FROM_CART"] = "remove-from-cart";
    DigitalDataMutation["CART_VIEW"] = "cart-view";
    DigitalDataMutation["COMPATIBILITY_CLICK"] = "compatibility-click";
    DigitalDataMutation["COMPATIBILITY_SEARCH_PRODUCT"] = "compatibility-search-product";
    DigitalDataMutation["COMPATIBILITY_SELECT_PRODUCT"] = "compatibility-select-product";
    DigitalDataMutation["CHECKOUT_LOGIN"] = "checkout-login";
    DigitalDataMutation["CHECKOUT_SHIPPING_DETAILS"] = "checkout-shipping-details";
    DigitalDataMutation["CHECKOUT_REVIEW"] = "checkout-review";
    DigitalDataMutation["CHECKOUT_PAYMENT_DETAILS"] = "checkout-payment-details";
    DigitalDataMutation["CHECKOUT_CONFIRMATION"] = "order-confirmation";
    DigitalDataMutation["CHECKOUT_DEALER_SEARCH"] = "checkout-shipping-details-dealer-search";
    DigitalDataMutation["CHECKOUT_DEALER_SELECT"] = "checkout-shipping-details-dealer-select";
    DigitalDataMutation["NAVIGATION"] = "navigation";
    DigitalDataMutation["FAQ_EXPANDED"] = "pdp-click-faq";
    DigitalDataMutation["FAQ_LISTING"] = "faq-listing";
    DigitalDataMutation["PDP_CHANGE_SIZE"] = "pdp-change-size";
    DigitalDataMutation["PDP_CHANGE_COLOR"] = "pdp-change-color";
    DigitalDataMutation["PDP_SKU_CHANGE"] = "pdp-sku-change";
    DigitalDataMutation["NOTIFY_ME_ENTRY"] = "notify-me-form-entry";
    DigitalDataMutation["NOTIFY_ME_CONFIRMATION"] = "notify-me-confirmation";
    DigitalDataMutation["PDP_CLICK_SPECIFICATION"] = "pdp-click-specification";
    DigitalDataMutation["PDP_CLICK_THUMBNAIL"] = "pdp-click-thumbnail";
    DigitalDataMutation["PDP_360"] = "pdp-360-view";
    DigitalDataMutation["ADD_PROMOCODE"] = "checkout-promo-activate";
    DigitalDataMutation["REMOVE_PROMOCODE"] = "checkout-promo-deactivate";
    DigitalDataMutation["TEST_RIDE_SELECT_PRODUCT"] = "test-ride-select-product";
    DigitalDataMutation["TEST_RIDE_SELECT_CATEGORY"] = "test-ride-select-category";
    DigitalDataMutation["TEST_RIDE_FORM_ENTRY"] = "test-ride-view-form-entry";
    DigitalDataMutation["TEST_RIDE_SELECT_HOUR"] = "test-ride-select-hour";
    DigitalDataMutation["TEST_RIDE_SELECT_DATE"] = "test-ride-select-date";
    DigitalDataMutation["MAINTENANCE_SELECT_HOUR"] = "maintenance-select-hour";
    DigitalDataMutation["MAINTENANCE_SELECT_DATE"] = "maintenance-select-date";
    DigitalDataMutation["TEST_RIDE_SELECT_CONTACT_METHOD"] = "test-ride-select-contact-method";
    DigitalDataMutation["MAINTENANCE_SELECT_CONTACT_METHOD"] = "maintenance-select-contact-method";
    DigitalDataMutation["CHANGE_SHIPPING_METHOD"] = "cart-change-shipping-method";
    DigitalDataMutation["CHECKOUT_CHANGE_SHIPPING_METHOD"] = "checkout-change-shipping-method";
    DigitalDataMutation["TEST_RIDE_SELECT_PDP"] = "test-ride-select-product";
    DigitalDataMutation["TEST_RIDE_CHANGE_MODEL"] = "test-ride-change-model";
    DigitalDataMutation["TEST_RIDE_SEARCH_DEALER"] = "test-ride-search-dealer";
    DigitalDataMutation["PDP_TECH_SPECS"] = "pdp-tech-specs";
    DigitalDataMutation["TEST_RIDE_CONFIRMATION"] = "test-ride-confirmation";
    DigitalDataMutation["COMPARE_VIEW"] = "compare-view";
    DigitalDataMutation["COMPARE_SELECT_ITEM"] = "compare-select-item";
    DigitalDataMutation["DEALER_LOCATOR_PAGE_VIEW"] = "dealer-locator-page-view";
    DigitalDataMutation["DEALER_LOCATOR_SELECT_COUNTRY"] = "dealer-locator-select-country";
    DigitalDataMutation["DEALER_LOCATOR_SELECT_LOCATION"] = "dealer-locator-select-location";
    DigitalDataMutation["DEALER_LOCATOR_SELECT_CATEGORY"] = "dealer-locator-select-category";
    DigitalDataMutation["DEALER_LOCATOR_SELECT_DEALER"] = "dealer-locator-select-dealer";
    DigitalDataMutation["EVENTS_DETAILS_VIEW"] = "event-detail-view";
    DigitalDataMutation["NEWS_DETAILS_VIEW"] = "news-detail-view";
    DigitalDataMutation["NEWS_ITEM_CLICK"] = "news-item-click";
    DigitalDataMutation["EVENTS_ITEM_CLICK"] = "events-item-click";
    DigitalDataMutation["NEWS_LIST_VIEW"] = "news-list-view";
    DigitalDataMutation["EVENT_LIST_VIEW"] = "event-list-view";
    DigitalDataMutation["NEWS_LIST_FILTER"] = "news-list-filter";
    DigitalDataMutation["EVENT_LIST_FILTER"] = "event-list-filter";
    DigitalDataMutation["TEST_RIDE_AVAILABILITY"] = "test-ride-availability";
    DigitalDataMutation["ABTEST_BANNER_VIEW"] = "ab-banner-view";
    DigitalDataMutation["ABTEST_BANNER_CLICK"] = "ab-banner-click";
    DigitalDataMutation["EDP_VIEW"] = "experience-detail-page-view";
    DigitalDataMutation["EDP_SEND_INQUIRY_VIEW"] = "experience-detail-send-inquiry";
    DigitalDataMutation["ELP_VIEW"] = "experience-list-page-view";
    DigitalDataMutation["ELP_FILTER"] = "experience-list-page-filter";
    DigitalDataMutation["CHECKOUT_EXCLUSION_CONFIRMATION"] = "checkout-exclusion-confirmation";
    DigitalDataMutation["RELATED_ITEMS_WIDGET_CLICK"] = "related-items-widget-click";
    DigitalDataMutation["CLICK_FROM_RELATED_WIDGET"] = "click-from-related-items-widget";
    DigitalDataMutation["FASLET_RECOMMENDED_SIZE"] = "faslet-recommended-size";
    DigitalDataMutation["FASLET_LOADED"] = "faslet-loaded";
    DigitalDataMutation["FASLET_ADDED_TO_CART"] = "faslet-added-to-card";
    DigitalDataMutation["OPEN_PARTS_CATALOG"] = "open-parts-catalog";
    DigitalDataMutation["RETURN_PAGE_VIEW"] = "return-page-view";
    DigitalDataMutation["RETURN_PAGE_ITEMS_VIEW"] = "return-page-items-view";
    DigitalDataMutation["RETURN_PAGE_PACKAGE_VIEW"] = "return-page-package-view";
    DigitalDataMutation["RETURN_PAGE_REQUEST_VIEW"] = "return-page-request-view";
    DigitalDataMutation["RETURN_PAGE_REQUEST_SUBMISSION_VIEW"] = "return-page-request-submission";
    DigitalDataMutation["SHOPPING_CART_POPUP_PROCEED_CLICK"] = "shopping-cart-popup-proceed-click";
    DigitalDataMutation["ACC_SELECT_MODEL_FILTER"] = "acc-select-model-filter";
})(DigitalDataMutation || (DigitalDataMutation = {}));
export const ListingMap = {
    [AEM_FUNCTIONS.plpAccessoriesGrid]: 'accessory-list-all',
    [AEM_FUNCTIONS.plpClothingMerchGrid]: 'apparel-list-all',
    [AEM_FUNCTIONS.plpUnitsGrid]: 'unit-list-all',
    [AEM_FUNCTIONS.clpUnitsGrid]: 'unit-list-all',
    [DigitalDataMutation.TEST_RIDE_VIEW_SEGMENT]: 'unit-list-all',
    [DigitalDataMutation.TEST_RIDE_VIEW_CATEGORY]: 'unit-list-all',
    [DigitalDataMutation.RMV_CMP]: 'unit-comparison-list',
    [DigitalDataMutation.ADD_CMP]: 'unit-comparison-list',
    [DigitalDataMutation.COMPARE_VIEW]: 'unit-comparison-list',
    [DigitalDataMutation.NEWS_ITEM_CLICK]: 'news-list',
    [DigitalDataMutation.EVENTS_ITEM_CLICK]: 'event-list',
    [DigitalDataMutation.NEWS_LIST_VIEW]: 'news-list',
    [DigitalDataMutation.EVENT_LIST_VIEW]: 'event-list',
    [DigitalDataMutation.NEWS_LIST_FILTER]: 'news-list',
    [DigitalDataMutation.EVENT_LIST_FILTER]: 'event-list',
    [DigitalDataMutation.ELP_VIEW]: 'experience-list',
    [DigitalDataMutation.ELP_FILTER]: 'experience-list-filter',
    destinationListing: 'destination-list',
    unitListing: 'unit-list-all',
    unknown: 'unknown-list-all',
};
export const DeduplicatedData = {
    [DigitalDataMutation.MAINTENANCE_SEARCH_DEALER]: new Set(),
    [DigitalDataMutation.CONFIGURATOR_SEARCH_DEALER]: new Set(),
    [DigitalDataMutation.LEAD_SEARCH_DEALER]: new Set(),
};
export const STATE_FOR_PRODUCT_OPTIONS_CLICK = {
    isInsideClick: false,
    timeoutId: 0,
    animationFrameId: 0,
};
export const GENERIC_CLICK_STATE = {
    isInsideClick: false,
    timeoutId: 0,
    animationFrameId: 0,
};
export const DEFAULT_PRODUCT_QUANTITY = 1;
export const DIGITAL_DATA_MANUFACTURER_NAME = 'yamaha';
